import React from 'react';
import Lottie from 'lottie-react';
import animationData2 from '../../assets/busFondoNegro.json';
import './styles.css';

export const LottieAnimation = ({ 
  height = 200,
  width = 200,
  containerHeight = "100vh",
  containerWidth = "100%",
  position = "fixed",
  top = "0",
  left = "0",

}) => {
  return (
    <div 
      className="container-lottie" 
      style={{ height: containerHeight, width: containerWidth , position, top, left }}
    >
      <Lottie 
        animationData={animationData2} 
        loop 
        autoplay 
        style={{ height, width }} 
      />   
    </div>
  );
};
